<template>
    <div class="commerce-view-btns">
        <div class="btn-item  btn-wow-effect-hover" :class="{'active' : commerceListView == 'list'}" @click="changeListView('list')"> 
            <svgIcon name="list-view" class="icon-list"/>
        </div>
        <div class="btn-item  btn-wow-effect-hover" :class="{'active' : commerceListView == 'grid'}" @click="changeListView('grid')">
            <svgIcon name="grid-view" class="icon-grid"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'commerce-view-btns',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            commerceListView: 'loadCommerceListView',
            // indexPage: 'loadIndexPage',
        }),
        methods: {
            changeListView(data) {
                this.$store.commit('changeCommerceListView', data)
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/commerce-page/commerce-view-btns.scss';
    @import '@/styles/components/commerce-page/respond/commerce-view-btns-respond.scss';
    // @import '@/styles/components/commerce-page/respond/commerce-view-btns-respond.scss';
</style>